import { type Ref, onMounted, ref } from 'vue';

export const useProjectRevenueForecastTableSHadow = (
	leftShadowWhenVisible: Ref<HTMLDivElement | undefined>,
	rightShadowWhenVisible: Ref<HTMLDivElement | undefined>
) => {
	const isForecastLastMonthVisible = ref(false);
	const isForecastFirstMonthVisible = ref(false);

	const isIntersecting = (entries: IntersectionObserverEntry[]) => {
		return entries.some((entry) => entry.isIntersecting);
	};

	onMounted(() => {
		const forecastTableObserverLastColumn = new IntersectionObserver(
			(entries) => {
				isForecastLastMonthVisible.value = !isIntersecting(entries);
			},
			{
				threshold: 0.9,
			}
		);
		const forecastTableObserverFirstColumn = new IntersectionObserver(
			(entries) => {
				isForecastFirstMonthVisible.value = !isIntersecting(entries);
			},
			{
				threshold: 0.9,
			}
		);

		if (leftShadowWhenVisible.value) {
			forecastTableObserverFirstColumn.observe(
				leftShadowWhenVisible.value
			);
		}

		if (rightShadowWhenVisible.value) {
			forecastTableObserverLastColumn.observe(
				rightShadowWhenVisible.value
			);
		}
	});

	return {
		isForecastLastMonthVisible,
		isForecastFirstMonthVisible,
	};
};
